{
  "id": 29,
  "location": "paris",
  "difficulty": "normal",
  "moves": 14,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "donut", "count": 22 }
  ],
  "stars": [2490, 3490],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . x x x x . .",
    ". . x . . x . .",
    ". . x . . x . .",
    ". . x x x x . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.659, "movesLeft": 3.4, "closeLosses": 0.135, "target": 0.63 }
}
